export const cmsPageEntityType = 'cms_page'
